import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function FeedbackLinkGenerator() {
  const [role, setRole] = useState('mentor');
  const [uid, setUid] = useState('');
  const [menteeId, setMenteeId] = useState('');
  const [milestone, setMilestone] = useState('kennenlerntermin');

  const basePath = '/feedback';

  const link =
    role === 'mentor'
      ? `${basePath}?uid=${uid}&milestone=${milestone}&role=mentor&mentee_id=${menteeId}`
      : `${basePath}?uid=${uid}&milestone=${milestone}&role=mentee`;

  return (
    <div className="p-4 space-y-4 bg-gray-900 text-white rounded shadow-md max-w-md">
      <h2 className="text-xl font-bold">Feedback-Link Generator</h2>

      <div className="space-y-2">
        <label className="block">
          Rolle:
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="ml-2 bg-gray-800 text-white border px-2 py-1"
          >
            <option value="mentor">Mentor:in</option>
            <option value="mentee">Mentee</option>
          </select>
        </label>

        <label className="block">
          Nutzer-ID (`uid`):
          <input
            type="text"
            value={uid}
            onChange={(e) => setUid(e.target.value)}
            className="ml-2 bg-gray-800 text-white border px-2 py-1"
          />
        </label>

        {role === 'mentor' && (
          <label className="block">
            Mentee-ID:
            <input
              type="text"
              value={menteeId}
              onChange={(e) => setMenteeId(e.target.value)}
              className="ml-2 bg-gray-800 text-white border px-2 py-1"
            />
          </label>
        )}

        <label className="block">
          Meilenstein:
          <input
            type="text"
            value={milestone}
            onChange={(e) => setMilestone(e.target.value)}
            className="ml-2 bg-gray-800 text-white border px-2 py-1"
          />
        </label>
      </div>

      <Link
        to={link}
        className="inline-block bg-green-500 text-black font-bold px-4 py-2 rounded hover:bg-green-400"
      >
        Zum Feedback-Formular
      </Link>

      <div className="text-xs mt-2 break-all text-gray-400">
        URL: {link}
      </div>
    </div>
  );
}
